"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

/**
 * Checkbox component
 */
var Checkbox = function Checkbox(_ref) {
  var _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      className = _ref.className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      onChange = _ref.onChange,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["checked", "className", "disabled", "onChange"]);
  return /*#__PURE__*/React.createElement("input", (0, _extends2["default"])({}, rest, {
    checked: checked,
    className: className,
    disabled: disabled,
    onChange: onChange,
    readOnly: !onChange,
    type: "checkbox"
  }));
};

exports["default"] = Checkbox;
//# sourceMappingURL=index.js.map